import React, { useEffect, useRef } from 'react';

export const VoiceVisualizer = ({ stream }) => {
  const barsRef = useRef([]);
  const animationRef = useRef(null);

  useEffect(() => {
    if (!stream) return;

    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const source = audioContext.createMediaStreamSource(stream);
    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 64;

    source.connect(analyser);
    const dataArray = new Uint8Array(analyser.frequencyBinCount);

    const animate = () => {
      analyser.getByteFrequencyData(dataArray);
      const step = Math.ceil(dataArray.length / barsRef.current.length);

      barsRef.current.forEach((bar, i) => {
        if (!bar) return;
        const avg = dataArray.slice(i * step, (i + 1) * step).reduce((a, b) => a + b, 0) / step;

        const variation = Math.sin(i + performance.now() / 300) * 0.2;
        const amplitude = 0.3 + (avg / 255) * 1.2 + variation;

        bar.style.transform = `scaleY(${Math.max(0.3, amplitude)})`;
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationRef.current);
      audioContext.close();
    };
  }, [stream]);

  const bars = 8;
  const totalBars = bars * 2;

  return (
    <div className="flex items-center justify-center gap-[2px] h-[24px]">
      {[...Array(totalBars)].map((_, i) => (
        <div
          key={i}
          ref={el => (barsRef.current[i] = el)}
          className="w-[3px] bg-gradient-to-t from-[#A598FF] via-[#6E98FF] to-[#B6F5FF] rounded-full transition-transform duration-75 origin-center"
          style={{ height: '20px', transform: 'scaleY(0.3)' }}
        />
      ))}
    </div>
  );
};
